<template>
<div>
  <b-container v-if="solicitud" fluid>
    <h1>Agregar adjunto a solicitud</h1>
    <b-card bg-variant="light" :title="solicitud.PersonalString.toUpperCase()">
      <item-lista-solicitud :item="solicitud"></item-lista-solicitud>
    </b-card>
    <b-row>
      <b-col cols="10">
        <b-alert v-if="!solicitud.Adjunto && solicitud.ListaAdjunto.length === 0" variant="danger" show>
          No existe archivo adjunto.
        </b-alert>
        <b-btn v-if="solicitud.Adjunto" target="_blank" :href="(this.cdn_file_url + solicitud.Adjunto)">Descargar {{solicitud.Adjunto}} <b-icon icon="download"></b-icon></b-btn>
        <b-list-group v-if="solicitud.ListaAdjunto">
          <b-list-group-item target="_blank" v-for="adj in solicitud.ListaAdjunto" :key="adj">{{adj}}</b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form v-if="true" enctype="multipart/form-data" @submit.stop.prevent="handleSubmit(onSubmit)">
            <b-form-row>
              <b-col>
                <validation-provider name="adjunto" :rules="{ required: true, ext: ['jpg', 'jpeg', 'jfif', 'png', 'pdf'], size: 3072 }" v-slot="validationContext">
                  <b-form-group id="inputAdjunto-group" label="Adjuntar archivo" label-for="inputAdjunto">
                    <b-form-file
                      class="mb-2"
                      v-model="inputAdjunto"
                      placeholder="Archivos permitidos: jpg, jpeg, jfif, png, pdf"
                      drop-placeholder="Suelte el archivo aquí..."
                      :state="checkForm(validationContext)"
                    ></b-form-file>
                    <b-button v-if="inputAdjunto" @click="inputAdjunto = null">Remover archivo </b-button>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col class="text-right">
                <b-button :disabled="disabled" class="mb-2" variant="warning" v-on:click="cerrarFormulario()">Cancelar</b-button>
                <b-button :disabled="disabled" class="mb-2" type="submit" variant="warning">Guardar</b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { mapGetters,mapActions } from 'vuex'
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import LicenciaCargoPersonalSvc from '@/services/licenciacargopersonal'
import PersonalSvc from '@/services/personal'
import Solicitudsvc from '@/services/solicitudes'
import CardDatosContacto from '../../common/CardDatosContacto'
import ItemListaSolicitud from '../../common/ListaSolicitudItem'
import TablaCargoPersonal from '../../common/TablaCargoPersonal'



import { createHelpers } from 'vuex-map-fields';



const { mapFields: mapFormSolicitudFields } = createHelpers({
  getterType: 'FormSolicitudModule/getSolicitudField',
  mutationType: 'FormSolicitudModule/updateSolicitudField',
});

const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: "RecibirSolicitudForm",
  mixins: [errorhandler, swalerts],
  components: { CardDatosContacto, ItemListaSolicitud, TablaCargoPersonal },
  computed: {
    ...mapFormBuscarPersonalFields(['Personal', 'ListaCargoPersonal', 'InputDni']),
    ...mapGetters(['getEstablecimiento','isInRoleAdmin','isInRoleCoordinador','isInRoleEstablecimiento','isInRoleRecMedico']),
    ...mapFormSolicitudFields(['TipoLicencia', 'DetalleDiasLicencia', 'EstadoSolicitudMedica', 'FechaDesde', 'Observaciones', 'CantidadDias', 'ListaCargoPersonalSeleccionado']),
  },
  props: {
    personal: Object,
    cargopersonal: Array
  },
  watch: {
  },
  data() {
    return {
      disabled: false,
      solicitud: null,
      inputAdjunto: null,
    };
  },
  watch: {
  },
  mounted(){
    this.solicitud = this.$route.params.solicitud;
  },
  methods: {
    ...mapActions("SolicitudModule", ["cambiarEstado"]),
    checkForm: function({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
      console.log('onSubmit');
      this.agregarAdjunto();
    },
    agregarAdjunto(){
      //this.desactivarBoton();
      this.disabled = true;
      this.inputFechaActual = moment();
      let formData = new FormData();
      formData.append("file", this.inputAdjunto);
      formData.append("serverpath", "solicitudlicencia");
      let filenameComprobante = this.inputAdjunto ? this.inputAdjunto.name : "";
      let comprobantename = `${moment().format("YYYYMMDDHHmmss")}_${filenameComprobante}`;
      formData.append("filename", comprobantename);
      return Solicitudsvc.agregarAdjunto({
        uploadfile: this.inputAdjunto ? true : false,
        Id: this.solicitud.Id,
        formdata: formData,
      }).then(r => {
        console.log('result agregarAdjunto', r);
        this.disabled = false;
        this.$router.push({ name: 'consultasolicitud', params: {  } });
      }).catch(e => {
        console.log('error agregarAdjunto', e);
        this.disabled = false;
        this.errorHandler(e);
      });
    },
    cerrarFormulario(mensaje){
      this.limpiarFormulario();
      if(mensaje){
        this.showSuccess(mensaje);
      }
      this.$router.push({ name: 'consultasolicitud', params: {  } });
    },
    limpiarFormulario()
    {
      this.inputAdjunto = null;
    },
  }
}
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/pages/solicitudes/AgregarAdjuntoForm.vue